import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import isAdmin from "../services/isAdmin";
import slugify from "slugify";
// import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import ReactLoading from "react-loading";
import { Button, DatePicker, message } from "antd";
import DatePickerReact from "react-datepicker";
import SelectReact from "react-select";
import moment from "moment";
import swal from "sweetalert";
import config from "../config";
import locations from "../utils/api/locations";
import { Skill_TRF_Id, Trf_Edit_Right } from "../umConfig";
import {
  changeDateTimeFormat,
  formatDate,
  formatDateDDMMYYYY,
} from "../utils/commonFunctions";
import BASE from "../config";
import StarRating from "react-star-ratings";
import {
  CalendarFilled,
  InfoCircleFilled,
  UserOutlined,
  ReloadOutlined,
  CheckCircleOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import saveLog from "../services/saveLog";
import {
  Formik,
  Form,
  Field,
  ErrorMessage,
  useField,
  useFormikContext,
} from "formik";
import RDatePicker from "react-datepicker";
import { Collapse, Breadcrumb } from "antd";
import { Badge, Card, Select, Typography, Tag, Rate, Image, Space } from "antd";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import RejectImage from "../images/reject.jpg";
// import RSelect from "react-select";
import CandidateForms from "./candidate/CandidateForms";
import useGetFile from "../hooks/useGetFile";
import useAuthUserToken from "../hooks/useAuthUserToken";
import useAxios from "../hooks/useAxios";
import ButtonHint from "./ButtonHint";
import * as Yup from "yup";
import Dashboard from "../layouts/Dashboard";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Header from "./components/Header";
import { useLocation } from "react-router-dom";
import ProfilePhotoMatch from "./components/ProfilePhotoMatch";
import TinManage from "../pages/Dashboard/components/TinManage";
import useRole from "../hooks/useRole";
import { checkPermission } from "../utils/checkPermission";

const { Option } = Select;
const { Title, Text } = Typography;
const AssessmentCard = ({
  competency,
  markQuestionAsked,
  submitRating,
  questionRefresh,
  intervieDetails,
  canTakeInterview,
}) => {
  const { competencyNames, questionList, starRating } = competency;

  const checkAllQuestionIsAsked = () => {
    return !questionList.every((que) => que.isQuestionMarked === true);
  };

  const disableChangeQuestion = () => {
    for (let que of questionList) {
      if (que.isQuestionMarked === true) {
        return true;
      }
    }
    return false;
  };

  return (
    <Card style={{ marginBottom: 16 }}>
      <div className="d-flex justify-content-between mb-2">
        <Title level={5}>{competencyNames}</Title>
        <button
          disabled={
            disableChangeQuestion() || !canTakeInterview
          }
          onClick={() => questionRefresh(competency?._id)}
          className="btn btn-outline-secondary  w-md-auto"
        >
          Change Question
        </button>
      </div>
      {questionList.map((question) => (
        <Space
          key={question?._id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "10px 0",
            borderBottom: "1px solid #999",
          }}
        >
          <Text>{question?.question}</Text>
          {question?.isQuestionMarked ? (
            <Text className="d-flex gap-1">
              Completed
              <CheckCircleOutlined
                style={{ fontSize: "24px", color: "green" }}
              />
            </Text>
          ) : (
            <Text
              className="d-flex gap-1"
              disabled={!canTakeInterview}
              onClick={() => {
                if (!canTakeInterview) return;
                markQuestionAsked(question?._id);
              }}
            >
              <CheckCircleOutlined
                style={{ fontSize: "20px", cursor: "pointer" }}
              />
            </Text>
          )}
        </Space>
      ))}
      <div style={{ marginTop: 8 }}>
        <Text>
          Rating:<span style={{ color: "red" }}>*</span> {starRating}/5
        </Text>
      </div>
      <div style={{ marginTop: 8 }}>
        <Rate
          allowHalf
          disabled={
            checkAllQuestionIsAsked() ||
            intervieDetails?.finished ||
            !canTakeInterview
          }
          count={5}
          onChange={(value) => {
            submitRating(competency?._id, value);
          }}
          defaultValue={starRating}
          allowClear={false}
          style={{ fontSize: 20 }}
        />
      </div>
    </Card>
  );
};

function InterviewProcess({ id }) {
  const locationUrl = useLocation();
  const searchParams = new URLSearchParams(locationUrl.search);
  const TAB = searchParams.get("tab" || "");
  const [competencybasedQuestions, setCompetencybasedQuestions] = useState({});
  const [reasons, setreasons] = useState([]);
  const competencies = competencybasedQuestions?.data || [];
  const intervieDetails = competencybasedQuestions?.interviewDetails || [];
  const [remarks, setRemarks] = useState("");
  const [interviewStatus, setInterviewStatus] = useState("");
  const [rejectedReason, setRejectedReason] = useState(null);
  const [reasonParameterList, setReasonParameterList] = useState([]);
  const [isVersantNotRequired, setIsVersantNotRequired] = useState(false);
  const [versantNotRequiredReason, setVersantNotRequiredReason] = useState("");
  const api = useAxios();
  const userRole = useRole();
  const [canTakeInterview, setCanTakeInterview] = useState(false);

  useEffect(() => {
    const fetchPerms = async () => {
      try {
        const allowed = await checkPermission(
          userRole,
          "candidate_profile_module",
          "take_interview"
        );
        setCanTakeInterview(allowed);
      } catch (err) {
        console.log(err);
      }
    };
    if (userRole) {
      fetchPerms();
    }
  }, [userRole]);
  const { userToken } = useAuthUserToken();
  const { getImage } = useGetFile(userToken);
  const { designationId, interviewId, interviewNameId, candidateId } =
    useParams();
  const [candidate, setCandidate] = useState();
  const [load, setLoad] = useState(false);
  const history = useHistory();
  const [interviewMode, setInterviewMode] = useState("Telephonic");
  const [photoMatch, setPhotoMatch] = useState(null);
  const [concent, setConcent] = useState(false);
  const [allBindTins, setAllBindTins] = useState([]);
  const [tinData, setTinData] = useState(null);
  const [mappingDetails, setMappingDetails] = useState(null);
  const [tinOptions, setTinOptions] = useState("");
  const [s3Files, setS3Files] = useState({
    resume: "",
    video: "",
    photo: "",
  });

  const currentVoice = allBindTins?.find(
    (t) => t?.tinType === "voice" && t?.tinStatus,
  );

  const currentWritten = allBindTins?.find(
    (t) => t?.tinType === "written" && t?.tinStatus,
  );

  const tinWrittenNumber = currentWritten?.tinNo || "";
  const tinVoiceNumber = currentVoice?.tinNo || "";

  const voiceScore = currentVoice?.scoreParts?.[0]?.scoreValue || 0;
  const writtenScore = currentWritten?.scoreParts?.[0]?.scoreValue || 0;
  const versantType = tinData?.versantBasedTRF?.versantType;

  const minVoiceScore = tinData?.versantBasedTRF?.voiceScore || 0;
  const minWrittenScore = tinData?.versantBasedTRF?.writtenScore || 0;

  const getTinDetails = () => {
    const details = [];
    if (versantType === "voice") {
      details?.push({
        tinNo: tinVoiceNumber,
        tintype: versantType,
      });
    }
    if (versantType === "written") {
      details?.push({
        tinNo: tinWrittenNumber,
        tintype: versantType,
      });
    }
    return details;
  };

  const calculateAverageRating = () => {
    if (competencies?.length !== 0) {
      const ratingSum = competencies.reduce((acc, ele) => {
        return acc + ele?.starRating || 0;
      }, 0);

      return ratingSum / competencies.length;
    }

    return 0;
  };

  const getReasonList = async () => {
    try {
      setLoad(true);
      const result = await api.get(`/statusParametersMaster`, {
        tokenType: "user",
      });
      setReasonParameterList(result.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };
  const getData = async () => {
    try {
      setLoad(true);
      const result = await api.get(
        `/competencyInterviewsetup/designation/${designationId}/interview/${interviewId}/interviewNames/${interviewNameId}`,
        { tokenType: "user" },
      );
      console.log(result.data);
      setCompetencybasedQuestions(result.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  const getCandidate = async () => {
    try {
      setLoad(true);
      const result = await api.get(`/candidates/${candidateId}`, {
        tokenType: "user",
      });
      let profilePhoto = null;
      let photo = "";
      if (result?.data?.files?.length !== 0) {
        for (let file of result?.data?.files) {
          if (file.fieldname) {
            if (file.fieldname.toLowerCase().indexOf("profile photo:") !== -1) {
              profilePhoto = file;
            }
          }
        }
      }
      if (profilePhoto) {
        photo = await getImage(profilePhoto?.path);
      }
      setS3Files({
        ...s3Files,
        photo: photo,
        video: "",
        resume: "",
      });
      setCandidate(result.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  const getBindTinByHr = async () => {
    try {
      const { data } = await api.get(
        `/manageTin/candidateTinListByHR/${candidate?._id}`,
        {
          tokenType: "user",
        },
      );
      setAllBindTins(data?.tinDetails);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getData();
    getReasonList();
    getCandidate();
  }, []);

  useEffect(() => {
    if (reasonParameterList.length !== 0 && interviewStatus) {
      for (let res of reasonParameterList) {
        if (res.name === interviewStatus) {
          setreasons(res.parameterList);
          return;
        }
      }
    }
  }, [interviewStatus, reasonParameterList]);

  useEffect(() => {
    if (competencybasedQuestions?.interviewDetails?.status) {
      setInterviewStatus(competencybasedQuestions.interviewDetails.status);
    }
    if (competencybasedQuestions?.interviewDetails?.rejectionReason) {
      setRejectedReason(
        competencybasedQuestions.interviewDetails.rejectionReason,
      );
    }

    if (competencybasedQuestions?.interviewDetails?.remarks) {
      setRemarks(competencybasedQuestions.interviewDetails.remarks);
    }
    if (competencybasedQuestions?.interviewDetails?.isVersantNotRequired) {
      setIsVersantNotRequired(competencybasedQuestions.interviewDetails.isVersantNotRequired);
    }
    if (competencybasedQuestions?.interviewDetails?.versantNotRequiredReason) {
      setVersantNotRequiredReason(competencybasedQuestions.interviewDetails.versantNotRequiredReason);
    }
  }, [competencybasedQuestions]);

  const getMappingDetails = async (_id) => {
    try {
      const { data } = await api.get(
        `/designationInterviewNamesMapping/${_id}`,
        {
          tokenType: "user",
        },
      );
      setMappingDetails(data?.designationInterviewsNamesMapping?.[0] || null)
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if(intervieDetails?.designationInterviewsNamesMappingId){
      getMappingDetails(intervieDetails?.designationInterviewsNamesMappingId)
    }
  },[intervieDetails])

  useEffect(() => {
    if (candidate?.trf && mappingDetails && mappingDetails?.interviewNamesId?.interviewNames === 'Versant Round') {
      getProcessBasedVersantConf();
      getBindTinByHr();
    }
  }, [mappingDetails, candidate?.trf]);

  const checkVersantCompleted = () => {
    if (versantType === "voice") {
      return voiceScore >= minVoiceScore;
    }

    if (versantType === "written") {
      return writtenScore >= minWrittenScore;
    }

    if (versantType === "both") {
      return voiceScore >= minVoiceScore && writtenScore >= minWrittenScore;
    }

    return false;
  };

  const onSubmit = async () => {
    if (interviewStatus === "Selected") {
      if (
        !candidate?.responses ||
        candidate?.responses?.length === 0 ||
        !(candidate?.isFormSubmitted === true || candidate?.isFormSubmitted === "true")
      ) {
        return swal({
          icon: "error",
          title: "Please complete candidate form",
        });
      }

      if (!candidate?.callMasterId || !candidate?.callStatusMasterId) {
        return swal({
          icon: "error",
          title: "Please fill Call Discussion Status first.",
        });
      }

      if (candidate?.callMasterId !== "Connected" && !candidate?.IsCallConnected) {
        return swal({
          icon: "error",
          title: "Call Discussion Status must be Connected to submit interview.",
        });
      }
    }

    if (
      interviewStatus === "Selected" &&
      mappingDetails?.interviewNamesId?.interviewNames == "Versant Round" &&
      tinOptions &&
      !isVersantNotRequired &&
      !checkVersantCompleted()
    ) {
      return swal({
        icon: "error",
        title: "Candidate not eligible for Versant Interview.",
      });
    }

    if (
      interviewStatus === "Selected" &&
      (interviewMode === "Video Call" || interviewMode === "In Person")
    ) {
      if (!candidatePhoto?.value) {
        return swal({
          icon: "error",
          title: "Please upload the candidate photo before proceeding.",
        });
      }
      if (photoMatch === null || !concent) {
        return swal({
          icon: "error",
          title: "Please Mark Photo Mismatch Status and Consent.",
        });
      }
    }

    try {
      setLoad(true);
      await api.patch(
        `/interviews/${interviewId}`,
        {
          finished: interviewStatus === "Selected" ? true : false,
          rating: [
            {
              name: "NA",
              rating: calculateAverageRating(),
              review: "",
            },
          ],
          remarks: remarks,
          status: interviewStatus,
          rejectionReason: interviewStatus === "Rejected" ? rejectedReason : "",
          clientRoundExist: null,
          isVersantNotRequired,
          versantNotRequiredReason: isVersantNotRequired ? versantNotRequiredReason : "",
          typingTest: false,
          typingTestRemarks: "",
          modeOfInterview: (candidate?.trf?.candidateType !== "Non-Agent") ? "Video Call" : (interviewStatus === "Selected" ? interviewMode : ""),
          profileImageMatchStatus:
            interviewStatus === "Selected" ? photoMatch : null,

          versantScore: false,
          versantScoreRemarks: "",
          clientRound: false,
          clientRoundRemarks: "",
          versantVoiceScore: voiceScore || null,
          versantWrittenScore: writtenScore || null,
          tinDetails: getTinDetails(),

          interviewBy: localStorage.getItem("user.id"),
          L4AttemptBy: "",
        },
        { tokenType: "user" },
      );

      if (interviewStatus === "Suspicious") {
        message.success(
          "Candidate marked as suspicious and inactive successfully.",
        );
        history.push(`/candidate_dashboard?tab=Application_Received`);
      } else {
        history.push(`/candidate/${candidateId}?tab=${TAB}`);
      }
    } catch (err) {
      swal({
        title: err.response.data.error,
        icon: "error",
      });
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  const disableSubmit = () => {
    const isRatingDone = competencies.every((comp) => comp.starRating > 0);
    if (
      isRatingDone &&
      interviewStatus !== "Pending" &&
      interviewStatus !== "" &&
      remarks.trim() !== ""
    ) {
      if (reasons.length !== 0) {
        if (!rejectedReason) return true;
      }
      if (isVersantNotRequired && !versantNotRequiredReason) return true;
      return false;
    } else {
      return true;
    }
  };

  const markQuestionAsked = async (_id) => {
    try {
      setLoad(true);
      const result = await api.put(
        `/competencyInterviewQuestionSets/updateQuestionStatus/${_id}`,
        {},
        { tokenType: "user" },
      );
      console.log(result.data);
      await getData();
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  const submitRating = async (_id, value) => {
    try {
      setLoad(true);
      const result = await api.post(
        `/competencyInterviewRating`,
        {
          competencyInterviewSetUpId: _id,
          interViewId: interviewId,
          starRating: value,
        },
        { tokenType: "user" },
      );
      console.log(result.data);
      await getData();
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  const questionRefresh = async (_id) => {
    try {
      setLoad(true);
      const result = await api.post(
        `/competencyInterviewsetup/refershCompetencyQuestion`,
        {
          designationId: designationId,
          interviewId: interviewId,
          interviewNameId: interviewNameId,
          competencyInterviewSteUpId: _id,
        },
        { tokenType: "user" },
      );
      console.log(result.data);
      await getData();
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  const selectStatus = async (status) => {
    if (
      !candidate?.responses ||
      candidate?.responses?.length === 0 ||
      !(candidate?.isFormSubmitted === true || candidate?.isFormSubmitted === "true")
    ) {
      const flag = await swal({
        icon: "error",
        title: "Please complete candidate form",
        buttons: true,
      });
      if (flag) {
        return history.push(
          `/edit/${candidate?.form?._id}/${candidateId}?tab=${TAB}&sourcepage=interview&ids=${designationId},${interviewId},${interviewNameId}`,
        );
      }
      return;
    }
    setInterviewStatus(status);
  };

  const getProcessBasedVersantConf = async () => {
    try {
      const { data } = await api.get(
        `/processBasedVersant/departmentId/${candidate?.trf?.departmentId}/designationId/${candidate?.trf?.designationId}/processId/${candidate?.trf?.processId}/location/${candidate?.trf?.location}/candidateId/${candidate?._id}`,
        { tokenType: "user" },
      );

      const type = data?.versantBasedTRF?.versantType;
      setTinData(data);
      setTinOptions(type);
    } catch (err) {
      console.error(err);
    }
  };

  const breadcrumbs = [
    {
      label: "Dashboard",
      url: `/candidate_dashboard?tab=${TAB}`,
    },
    {
      label: "Candidate",
      url: `/candidate/${candidate?._id}?tab=${TAB}`,
    },
    {
      label: candidate?.name,
      url: "",
    },
  ];

  const CALL_CONNECTED_STATUS = !(candidate?.callMasterId || candidate?.callStatusMasterId);

  const candidatePhoto = candidate?.responses?.find((ele) => {
    if (ele?.element.type === "file" || ele?.element?.type === "capturephoto") {
      const fieldName = ele?.element.properties.label;
      if (fieldName.toLowerCase().indexOf("profile photo") === 0) {
        return true;
      }
    }
  });

  const filterStatus =
    photoMatch === null ? "All" : photoMatch ? "All" : "Suspicious";

  return (
    <div>
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <Dashboard title="">
        <div className="candidate-details">
          <div className="container">
            <Header
              candidate={candidate}
              setLoad={setLoad}
              breadcrumbs={breadcrumbs}
            />

            {intervieDetails?.finished ? (
              <>
                <div className="row">
                  <div className="col-12 ">
                    <Card className="border mb-4 bg-white" title="">
                      <Card>
                        <div className="d-flex justify-content-between">
                          <div className="d-flex gap-1 align-items-center">
                            <Title className="mb-0" level={5}>
                              <strong>Interview Type :</strong>
                            </Title>
                            <span style={{ fontSize: "14px" }}>
                              {intervieDetails?.modeOfInterview}
                            </span>
                          </div>
                          {intervieDetails?.modeOfInterview !==
                            "Telephonic" && (
                            <div className="mt-2 d-flex align-items-center gap-1">
                              <div>
                                <Image
                                  style={{
                                    width: "120px",
                                    height: "90px",
                                    border: "1px solid #e3e6f0",
                                  }}
                                  src={s3Files?.photo}
                                />
                              </div>
                              <span className="d-flex">
                                {intervieDetails?.profileImageMatchStatus ? (
                                  <CheckOutlined
                                    style={{
                                      borderRadius: "50%",
                                      padding: 2,
                                      marginRight: "5px",
                                    }}
                                    className={"__initial_accepted_icon"}
                                  />
                                ) : (
                                  <CloseOutlined
                                    style={{
                                      borderRadius: "50%",
                                      padding: 2,
                                      marginRight: "5px",
                                    }}
                                    className={"__initial_rejected_icon"}
                                  />
                                )}
                                <span
                                  className="ml-2 font-weight-bold"
                                  style={{
                                    color:
                                      intervieDetails?.profileImageMatchStatus
                                        ? "#00AC1A"
                                        : "red",
                                  }}
                                >
                                  {intervieDetails?.profileImageMatchStatus
                                    ? "Matched"
                                    : "UnMatched"}
                                </span>
                              </span>
                            </div>
                          )}
                        </div>
                      </Card>
                    </Card>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            {competencies?.length !== 0 && (
              <div className="row">
                <div className="col-12 ">
                  <Card className="border mb-4 bg-white" title="Assessment">
                    {" "}
                    {competencies?.map((comp) => {
                      return (
                        <AssessmentCard
                          key={comp?._id}
                          intervieDetails={intervieDetails}
                          competency={comp}
                          questionRefresh={questionRefresh}
                          submitRating={submitRating}
                          markQuestionAsked={markQuestionAsked}
                          canTakeInterview={canTakeInterview}
                        />
                      );
                    })}
                  </Card>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-12 ">
                <Card
                  className="border mb-4 bg-white"
                  title={`Overall Feedback (${calculateAverageRating()})`}
                >
                  <div className="px-2">
                    {mappingDetails?.interviewNamesId?.interviewNames == "Versant Round" && tinOptions && (
                      <div className="mt-1 mb-4 px-1" style={{maxWidth : '515px'}}>
                        <h4 className="hr-ratings-title mt-0">
                          Versant Interview Ratings
                        </h4>
                        <TinManage
                          getProcessBasedVersantConf={
                            getProcessBasedVersantConf
                          }
                          getBindTinByHr={getBindTinByHr}
                          candidate={candidate}
                          tinData={tinData}
                          interview={intervieDetails}
                          versantRoundTin={""}
                          versantRoundTinType={""}
                          allBindTins={allBindTins}
                        />

                        <div className="row mt-3 mb-2 px-1">
                          <div className="col-12 d-flex align-items-center">
                            <input
                              type="checkbox"
                              id="isVersantNotRequired"
                              checked={isVersantNotRequired}
                              disabled={intervieDetails?.finished || !canTakeInterview}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setIsVersantNotRequired(checked);
                                if (!checked) setVersantNotRequiredReason("");
                                if (checked) {
                                  saveLog(
                                    "VERSANT_NOT_REQUIRED",
                                    `Marked Versant as Not Required for candidate ${candidate?.name}`
                                  );
                                }
                              }}
                            />
                            &nbsp;&nbsp;
                            <label htmlFor="isVersantNotRequired" className="mb-0 font-weight-bold">
                              Versant Not Required
                            </label>
                          </div>
                          {isVersantNotRequired && (
                            <div className="col-12 mt-2">
                              <label className="font-weight-bold">Reason <span className="text-danger">*</span></label>
                              <select
                                className="form-control"
                                value={versantNotRequiredReason}
                                disabled={intervieDetails?.finished || !canTakeInterview}
                                onChange={(e) => setVersantNotRequiredReason(e.target.value)}
                              >
                                <option value="">Select Reason</option>
                                <option value="Regional Candidate">Regional Candidate</option>
                                <option value="Movement from NAPS/NATS">Movement from NAPS/NATS</option>
                              </select>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="flex gap-1">
                          <div style={{ width: "145px" }} className="">
                            <Title level={5}>
                              Status:<span style={{ color: "red" }}>*</span>
                            </Title>
                          </div>
                          <div className="col-9">
                            {filterStatus === "All" ? (
                              <div className="row gap-1">
                                <button
                                  style={{
                                    ...(interviewStatus === "Selected"
                                      ? {
                                          backgroundColor: "#5a5c69",
                                          borderColor: "#5a5c69",
                                          color: "#fff",
                                        }
                                      : {}),
                                  }}
                                  disabled={
                                    intervieDetails?.finished ||
                                    intervieDetails?.rejectionReason !== "" ||
                                    !canTakeInterview
                                  }
                                  onClick={(e) => {
                                    selectStatus("Selected");
                                  }}
                                  className="btn btn-outline-secondary  w-md-auto"
                                >
                                  Selected
                                </button>
                                <button
                                  style={{
                                    ...(interviewStatus === "On Hold"
                                      ? {
                                          backgroundColor: "#5a5c69",
                                          borderColor: "#5a5c69",
                                          color: "#fff",
                                        }
                                      : {}),
                                  }}
                                  disabled={
                                    intervieDetails?.finished ||
                                    intervieDetails?.rejectionReason !== "" ||
                                    !canTakeInterview
                                  }
                                  onClick={(e) => selectStatus("On Hold")}
                                  className="btn btn-outline-secondary  w-md-auto"
                                >
                                  Hold
                                </button>
                                <button
                                  style={{
                                    ...(interviewStatus === "Drop"
                                      ? {
                                          backgroundColor: "#5a5c69",
                                          borderColor: "#5a5c69",
                                          color: "#fff",
                                        }
                                      : {}),
                                  }}
                                  disabled={
                                    intervieDetails?.finished ||
                                    intervieDetails?.rejectionReason !== "" ||
                                    !canTakeInterview
                                  }
                                  onClick={(e) => selectStatus("Drop")}
                                  className="btn btn-outline-secondary  w-md-auto"
                                >
                                  Drop
                                </button>
                                <button
                                  style={{
                                    ...(interviewStatus === "Rejected"
                                      ? {
                                          backgroundColor: "#5a5c69",
                                          borderColor: "#5a5c69",
                                          color: "#fff",
                                        }
                                      : {}),
                                  }}
                                  disabled={
                                    intervieDetails?.finished ||
                                    intervieDetails?.rejectionReason !== "" ||
                                    !canTakeInterview
                                  }
                                  onClick={(e) => selectStatus("Rejected")}
                                  className="btn btn-outline-secondary  w-md-auto"
                                >
                                  Rejected
                                </button>
                              </div>
                            ) : (
                              <div className="row gap-1">
                                <button
                                  style={{
                                    ...(interviewStatus === "Suspicious"
                                      ? {
                                          backgroundColor: "#5a5c69",
                                          borderColor: "#5a5c69",
                                          color: "#fff",
                                        }
                                      : {}),
                                  }}
                                  disabled={
                                    intervieDetails?.finished ||
                                    intervieDetails?.rejectionReason !== "" ||
                                    !canTakeInterview
                                  }
                                  onClick={(e) => selectStatus("Suspicious")}
                                  className="btn btn-outline-secondary  w-md-auto"
                                >
                                  Suspicious
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                        {(interviewStatus === "Selected" ||
                          interviewStatus === "Suspicious") &&
                          !intervieDetails?.finished && (
                            <div className="row mt-4">
                              <div className="col-12">
                                <ProfilePhotoMatch
                                  space={161}
                                  interview={intervieDetails}
                                  photoMatch={photoMatch}
                                  setPhotoMatch={setPhotoMatch}
                                  candidatePhoto={s3Files?.photo}
                                  interviewMode={interviewMode}
                                  setInterviewMode={setInterviewMode}
                                  setInterviewStatus={setInterviewStatus}
                                  candidatePhotoPresent={candidatePhoto?.value}
                                  setConcent={setConcent}
                                  concent={concent}
                                  canTakeInterview={canTakeInterview}
                                />
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    {reasons?.length !== 0 && (
                      <div className="row mt-3">
                        <div className="col-md-12">
                          <div className="flex gap-2">
                            <div style={{ width: "145px" }} className="">
                              <Title level={5}>
                                Reason:<span style={{ color: "red" }}>*</span>
                              </Title>
                            </div>
                            <div className="w-full" style={{maxWidth : '345px'}}>
                                <Select
                                  defaultValue=""
                                  placeholder="Select Reason"
                                  value={rejectedReason}
                                  style={{ width: "100%" }}
                                  onChange={(value) => {
                                    setRejectedReason(value);
                                  }}
                                  disabled={
                                    intervieDetails?.finished ||
                                    intervieDetails?.rejectionReason !== "" ||
                                    !canTakeInterview
                                  }
                                >
                                  {reasons?.map((res) => {
                                    return (
                                      <Select.Option value={res?.parameterName}>
                                        {res?.parameterName}
                                      </Select.Option>
                                    );
                                  })}
                                </Select>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="row mt-3">
                      <div className="col-md-12">
                        <div className="flex gap-1">
                          <div style={{ width: "145px" }} className="">
                            <Title level={5}>
                              Remarks:<span style={{ color: "red" }}>*</span>
                            </Title>
                          </div>
                          <div className="w-full" style={{maxWidth : '345px'}} >
                              <textarea
                                disabled={
                                  intervieDetails?.finished ||
                                  intervieDetails?.rejectionReason !== "" ||
                                  !canTakeInterview
                                }
                                placeholder="Type here..."
                                className="border form-control"
                                onChange={(e) => setRemarks(e.target.value)}
                                value={remarks}
                              ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-12">
                        <div className="d-flex">
                          <div style={{ width: "161px" }} className=""></div>
                          <div className="col-9">
                            <div className="row">
                              {canTakeInterview && (
                                <button
                                  disabled={
                                    disableSubmit() ||
                                    intervieDetails?.finished ||
                                    intervieDetails?.rejectionReason !== ""
                                  }
                                  className={`btn ${
                                    !disableSubmit() &&
                                    !intervieDetails?.finished &&
                                    intervieDetails?.rejectionReason === ""
                                      ? "btn-primary"
                                      : "btn-secondary"
                                  }`}
                                  onClick={async () => {
                                    let isCall = true;
                                    if (interviewStatus === "Suspicious") {
                                      isCall = await swal({
                                        icon: "error",
                                        title: "Do you want to continue?",
                                        text: "Selecting this option will deactivate the candidate account.",
                                        buttons: {
                                          cancel: "Cancel",
                                          confirm: "OK",
                                        },
                                      });
                                    }

                                    if (isCall) {
                                      onSubmit(intervieDetails?._id);
                                    }
                                  }}
                                >
                                  Submit
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </Dashboard>
    </div>
  );
}

export default InterviewProcess;
